<svg-icon src="Flag" preserveAspectRatio="none"
class="m-2.5" [ngbTooltip]="tooltipText" [placement]="tooltipPlacement" [stretch]="true"></svg-icon>